import { useEffect } from 'react';
import EmailCard from '../components/card/email-card';
import { useEmailThreads } from './email-threads-context';
import EmailControllerHeader from '../components/email-controller-header';
import PropTypes from 'prop-types';
import EmailListSkeleton from '../components/email-list-skeleton';
import EmailEmptyState from '../components/email-empty-state';
import { useIsFilterApplied, useIsLabelFilterApplied } from '../utils/filter-search-helper';

const ThreadController = ({ dateRange, replyStatus, replyDateRange, emailRecipients, selectedNames, filterType }) => {
  const { threads, loading, page, onPageChange, threadTotal, threadLimit, searchThreads, hasEverHadData } =
    useEmailThreads();

  //checks to see what / if any filters are applied
  const isAnyFilterApplied = useIsFilterApplied({
    dateRange,
    replyDateRange,
    replyStatus,
    emailRecipients,
    selectedNames,
  });

  //checks if date and status filter is applied
  const isLabelFilterApplied = useIsLabelFilterApplied({
    dateRange,
    replyDateRange,
    replyStatus,
  });

  useEffect(() => {
    const fetchThreads = async () => {
      if (isAnyFilterApplied) {
        await searchThreads({ dateRange, replyStatus, replyDateRange, emailRecipients, selectedNames });
      }
    };

    fetchThreads();
  }, [isAnyFilterApplied, searchThreads, dateRange, replyDateRange, replyStatus, emailRecipients, selectedNames, page]);

  useEffect(() => {
    return () => {
      onPageChange(1);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? (
        <EmailListSkeleton />
      ) : (
        <>
          {(threads?.length === 0 || threads === null) && (
            <EmailEmptyState type="sent" isFilterApplied={isAnyFilterApplied && hasEverHadData} />
          )}
          {threads?.length > 0 && (
            <div className="email-controller-container">
              <EmailControllerHeader
                selectedCount={0}
                totalCount={threads?.length || 0}
                label="Sent"
                page={page}
                onPageChange={onPageChange}
                totalPages={Math.ceil(threadTotal / threadLimit)}
              />
              {!!threads?.length &&
                threads.map(({ nylas_thread_id, email_count, display_email = {} }) => (
                  <EmailCard
                    key={nylas_thread_id}
                    email={display_email || {}}
                    threadCount={email_count}
                    isLabelFilterApplied={isLabelFilterApplied}
                    filterType={filterType}
                  />
                ))}
            </div>
          )}
        </>
      )}
    </>
  );
};

ThreadController.propTypes = {
  dateRange: PropTypes.shape({
    from: PropTypes.instanceOf(Date),
    to: PropTypes.instanceOf(Date),
  }),
  replyDateRange: PropTypes.shape({
    from: PropTypes.instanceOf(Date),
    to: PropTypes.instanceOf(Date),
  }),
  replyStatus: PropTypes.string,
  emailRecipients: PropTypes.object,
  selectedNames: PropTypes.arrayOf(PropTypes.object),
  filterType: PropTypes.string,
};

export default ThreadController;
